"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAddress = exports.toRawAddress = exports.toUserFriendlyAddress = void 0;
const ton3_core_1 = require("ton3-core");
const toUserFriendlyAddress = (address) => {
    return (0, exports.parseAddress)(address).toString("base64");
};
exports.toUserFriendlyAddress = toUserFriendlyAddress;
const toRawAddress = (address) => {
    return (0, exports.parseAddress)(address).toString("raw");
};
exports.toRawAddress = toRawAddress;
const parseAddress = (address) => {
    return new ton3_core_1.Address(address);
};
exports.parseAddress = parseAddress;
